import { Component, OnInit } from "@angular/core";
import { ProductList } from "../../../../../model/finzy-flex/product-list.model";
import { LenderBasicInfo } from "../../../../../model/lender.model";
import { Toaster, Type } from "../../../../../toaster/Toaster";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-portfolio-creation',
    templateUrl: './portfolio-creation.component.html',
    styleUrls: ['./portfolio-creation.component.scss']
})
export class PortfolioCreationComponent implements OnInit {
    public lenderBasicInfo: LenderBasicInfo;
    public productsData: ProductList;
    public flexInvestmentAmount: number;
    public maxInvestmentAmount: number;

    constructor(
        activatedRoute: ActivatedRoute,
    ) {
        activatedRoute.data.subscribe((data) => {
            this.productsData = data.subProduct;
            this.lenderBasicInfo = data.lenderBasicInfo;
            this.flexInvestmentAmount = data.flexInvestmentAmount;
            this.maxInvestmentAmount = data.maxInvestmentAmount;
        });
    }

    private async getSubProductsList() {
        try {
            const subProductsFiltered = this.productsData.data.filter(product => (new Date(product.productVersions[0].startDate).getTime() <= new Date().getTime() &&
            new Date().getTime() <= new Date(product.productVersions[0].endDate).getTime()));
            this.productsData = {
                count: this.productsData.count,
                data: subProductsFiltered,
                status: this.productsData.status,
                total: this.productsData.total,
            }
            return this.productsData;
        } catch(error) {
            return Toaster.toast(`Something went wrong.`, Type.Error);
        }
    }

    ngOnInit(): void {
        this.getSubProductsList();
    }
}